// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr;
}
@media screen and (min-width: 576px) {
.stats-grid {
    grid-template-columns: 1fr 1fr;
}
}
@media screen and (min-width: 768px) {
.stats-grid {
    grid-template-columns: 1fr 1fr 1fr 1fr;
}
}
@media screen and (min-width: 992px) {
.stats-grid {
    grid-template-columns: 1fr 1fr;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
